<div class="modalClose">
  <img src="/assets/img/shared/close.svg" (click)="cancel()" />
</div>
<ion-content [fullscreen]="true">
  <ion-grid>
    <ion-row>
      <ion-col class="mx-8">
        <h2>Fjern bil fra appen</h2>
        <p class="pt-2 my-8">
          Om du ønsker å fjerne en bil fra appen kan du gjøre det her. Du kan
          legge til bilen igjen senere.
        </p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-list>
          <ion-item>
            <ion-select 
              placeholder="Velg leverandør" 
              [(ngModel)]="selectedVendor"
              interface="popover"
              justify="space-between"
              labelPlacement="stacked"
              [interfaceOptions]="{
                header: 'Velg leverandør',
              }"
              value="{{ !multipleVendors ? selectedVendor : '' }}"
            >
              <ion-select-option *ngFor="let vendor of allVendors " [value]="vendor">
                {{ vendor }}
              </ion-select-option>
            </ion-select>
          </ion-item>
        </ion-list>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        @if (allVendorsCount[selectedVendor] > 1 && vehicles.length > 1) {
          <p class="mx-8">
            Siden du har flere biler fra <strong>{{ selectedVendor }}</strong> koblet til vil alle bli fjernet fra appen.
            Om du ønsker å smartlade en av de må du koble den til på nytt.
          </p>
        }
        @if ((multipleVendors && selectedVendor) || (!multipleVendors)) {
          <p>
            Du fjerner nå <strong>{{ selectedVendor }}</strong> fra appen.
          </p>
        }
      </ion-col>
    </ion-row>
    <ion-row class="mt-8">
      <ion-col>
        <div class="flex gap-2 justify-center">
          <ion-button (click)="cancel()">
            Avbryt
          </ion-button>
          <ion-button class="dark" (click)="deleteVehicle()" disabled="{{!selectedVendor}}">
            Fjern bil
          </ion-button>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>